import AppImage from '@/components/ui/AppImage';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative bg-primary text-primary-foreground overflow-hidden ${className}`}>
      <div className="absolute inset-0 opacity-10">
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_173e30a36-1767018661005.png"
          alt="Professional cleaning team in uniform working together in modern office space"
          fill
          className="object-cover"
          priority />

      </div>
      <div className="relative container mx-auto px-4 py-20 lg:py-28">
        <div className="max-w-3xl">
          <h1 className="text-4xl lg:text-5xl font-heading font-bold mb-6">
            Rejoignez Notre Équipe
          </h1>
          <p className="text-lg lg:text-xl mb-8 opacity-90">
            Nous recherchons des travailleurs passionnés pour rejoindre notre équipe de nettoyage professionnel. Construisez votre carrière avec Rouissi Services et bénéficiez d'opportunités de croissance dans un environnement de travail positif.
          </p>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center space-x-2">
              <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-accent-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <p className="font-heading font-semibold">Salaire Compétitif</p>
                <p className="text-sm opacity-80">CHF 22-28/heure</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-accent-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div>
                <p className="font-heading font-semibold">Croissance Rapide</p>
                <p className="text-sm opacity-80">Opportunités d'avancement</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;